import {
    ROUTES_REPORTS_RACING_MULTIPLE_CREWS_MULTIPLE_PIECES,
    ROUTES_REPORTS_RACING_MULTIPLE_CREWS_MULTIPLE_SESSIONS,
    ROUTES_REPORTS_RACING_MULTIPLE_CREWS_SINGLE_PIECE,
    ROUTES_REPORTS_RACING_REPORT,
    ROUTES_REPORTS_RACING_SINGLE_CREW_SESSION_PIECES,
    ROUTES_REPORTS_RACING_SINGLE_CREW_SINGLE_SESSION,
    ROUTES_SWITCH_CLUB
} from '@/constants/routes';
import store from '@/store';
import { guardRoute } from '@/router';
import { decodeJSON } from '@/helpers/encryptionHelper';
import { i18n } from '@/lang';

export const REPORTS_ROUTES_AUS = [
    {
        name: ROUTES_REPORTS_RACING_REPORT,
        path: 'racing',
        beforeEnter: guardRouteRacingReport,
        component: () =>
            import(/*webpackChunkName: 'reports-racing'*/ '@/components/reports/racing-report/racing/Racing')
    },
    {
        name: ROUTES_REPORTS_RACING_SINGLE_CREW_SINGLE_SESSION,
        path: 'racing-single-crew-session/:uuid',
        beforeEnter: guardRouteRacingReports,
        component: () =>
            import(
                /*webpackChunkName: 'reports-racing'*/ '@/components/reports/racing-report/racing-data/single-crew-single-session/SingleCrewSingleSession'
            )
    },
    {
        name: ROUTES_REPORTS_RACING_SINGLE_CREW_SESSION_PIECES,
        path: 'racing-single-crew-session-pieces/:uuid',
        beforeEnter: guardRouteRacingReports,
        component: () =>
            import(
                /*webpackChunkName: 'reports-racing'*/ '@/components/reports/racing-report/racing-data/single-crew-session-pieces/SingleCrewSessionPieces'
            )
    },
    {
        name: ROUTES_REPORTS_RACING_MULTIPLE_CREWS_SINGLE_PIECE,
        path: 'racing-multiple-crews-single-piece/:uuid',
        beforeEnter: guardRouteRacingReports,
        component: () =>
            import(
                /*webpackChunkName: 'reports-racing'*/ '@/components/reports/racing-report/racing-data/multiple-crews-single-piece/MultipleCrewsSinglePiece'
            )
    },
    {
        name: ROUTES_REPORTS_RACING_MULTIPLE_CREWS_MULTIPLE_SESSIONS,
        path: 'racing-multiple-crews-multiple-sessions/:uuid',
        beforeEnter: guardRouteRacingReports,
        component: () =>
            import(
                /*webpackChunkName: 'reports-racing'*/ '@/components/reports/racing-report/racing-data/multiple-crews-multiple-sessions/MultipleCrewsMultipleSessions'
            )
    },
    {
        name: ROUTES_REPORTS_RACING_MULTIPLE_CREWS_MULTIPLE_PIECES,
        path: 'racing-multiple-crews-multiple-pieces/:uuid',
        beforeEnter: guardRouteRacingReports,
        component: () =>
            import(
                /*webpackChunkName: 'reports-racing'*/ '@/components/reports/racing-report/racing-data/multiple-crews-multiple-pieces/MultipleCrewsMultiplePieces'
            )
    }
];

function guardRouteRacingReport(to, from, next) {
    const notInFeatureSet = !store.getters['clubPermissions/canViewFeatureRacingReport'];
    const unauthorized = !store.getters['userPermissions/canViewRacingReport'];
    guardRoute(next, unauthorized, notInFeatureSet);
}

function guardRouteRacingReports(to, from, next) {
    let selected;
    try {
        selected = decodeJSON(to.params.uuid);
    } catch (e) {
        // swallow error
    }

    if (!selected || !selected.club_id) {
        store.dispatch('notifyError', { message: i18n.t('notValidUrl') });
        next({ name: ROUTES_REPORTS_RACING_REPORT });
    } else {
        const belongsToAnotherClub = selected.club_id !== store.getters.selectedClubId;
        if (belongsToAnotherClub) {
            store.dispatch('notifyError', { message: i18n.t('thisReportBelongsToAnotherClub') });
            next({ name: ROUTES_SWITCH_CLUB, params: { clubId: selected.club_id } });
        } else {
            guardRouteRacingReport(to, from, next);
        }
    }
}
